import { RowResult } from "../components/report-view/report-render/models/row-result.model";
import { Column } from "../components/report/models/column.model";
import { Filter } from "../components/report/models/filter.model";
import { ReportEntity } from "../components/report/models/report-entity.model";
import { Report } from "../components/report/models/report.model";
import { FilterTypeEnum } from "../enums/filter-type.enum";
import { QueryParameterRequest } from "../requests/query-parameter.request";
import { getAllColumns, getColumnFilter } from "./column.helper";
import { getDateFromFormat } from "./date-time.helper";
import { getEntityByColumn } from "./entity.helper";
import { getFilterByName } from "./filter.helper";

export function getQueryParameterList(parameter: any, filters: Filter[]): Array<QueryParameterRequest> {
    const parameters = [];

    for (const item of Object.keys(parameter)) {
      const filter = getFilterByName(filters, item);
      if (filter) {
        const obj = new QueryParameterRequest(item, parameter[item], filter.Required, filter.ColumnType.SystemType, filter.Type);
        parameters.push(obj);
      }
    }
    return parameters;
}

export function getGroupParameterName(entity: ReportEntity, column: Column): string {
    let parameter = `${entity.Alias}_${column.Name}`.replace(/\s/g, '').replace('(', '').replace(')', '');
    const length = parameter.length;
    const max = 30;

    if (length > max) {
      parameter = parameter.substring(0, max);
    }

    return parameter;
}

  export function getQueryParameter(report: Report, parameters: QueryParameterRequest[], row: RowResult): Array<QueryParameterRequest> {
    const list: Array<QueryParameterRequest> = parameters.concat();

    if (row) {
      for (const item of Object.keys(row.Data)) {
        const columns = getAllColumns(report);
        const column = getColumnFilter(item, columns);
        if (column != null) {
          const entity = getEntityByColumn(report, column);

          if (entity != null) {
            let value = row.Data[item];

            if (column.SystemType === 'DATE') {
              value = new Date(getDateFromFormat(value, 'dd/MM/yyyy HH:mm:ss'));
            }

            list.push(new QueryParameterRequest(
              getGroupParameterName(entity, column), value, false, column.SystemType, FilterTypeEnum.Equal
            ));
          }
        }
      }
    }

    return parameters;
}

export function getExportQueryParameter(report: Report, parameters: QueryParameterRequest[]): Array<QueryParameterRequest> {
    const columns = getAllColumns(report);
    const list = getQueryParameter(report, parameters, null);

    columns.filter(x => x.IsGroupBy).forEach(column => {
      const entity = getEntityByColumn(report, column);

      if (!!entity) {
        list.push(new QueryParameterRequest(
          getGroupParameterName(entity, column), '', false, column.SystemType, FilterTypeEnum.Equal
        ));
      }
    });

    return list;
}